// extracted by mini-css-extract-plugin
export var desktopLogo = "header-module--desktopLogo--v9en2";
export var endpiece = "header-module--endpiece--h-PWI";
export var header = "header-module--header--Zms1V";
export var logo = "header-module--logo--mTLiM";
export var mobileLogo = "header-module--mobileLogo--M2Rp8";
export var mobileMenuBtn = "header-module--mobileMenuBtn--XAQlT";
export var mobileNav = "header-module--mobileNav--AQifc";
export var navBtn = "header-module--navBtn--IfhDa";
export var searchBtn = "header-module--searchBtn--b5JoO";